import { useState } from "react";
import { toast } from "sonner";
import { MessageCircle, Mail, Download, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { receiptPdf, download, waNumber } from "@/lib/pdf";
import { api } from "@/lib/api";

const contactLine = (i) =>
  i.counselorMobile ? `\n\nFor any queries, call or WhatsApp your counsellor ${i.counselorName} on ${i.counselorMobile}.` : "";

const waMessage = (school, link, i) =>
  `Thanks for visiting ${school}. We look forward to working together on your Child's Journey of Education.\n` +
  `Here is a copy of the counsellor receipt for your perusal:\n${link}\n\n` +
  `Reserve your seat - scan this QR to pay (Admission AY 2027-28):\n${window.location.origin}/reserve-seat-qr.png` + contactLine(i);

export const ShareActions = ({ inputs, c, receiptNo, receiptId, schoolName }) => {
  const [busy, setBusy] = useState(null);
  const name = `${receiptNo || "Receipt"}_${(inputs.childName || "student").replace(/\s+/g, "_")}.pdf`;

  const sendWhatsApp = async () => {
    const num = waNumber(inputs.contact);
    if (num.length < 10) return toast.error("Enter the parent's Contact (WhatsApp) number first");
    if (!receiptId) return toast.error("Save the receipt first, then send it on WhatsApp");
    const win = window.open("", "_blank");
    setBusy("wa");
    try {
      const { blob } = await receiptPdf(name);
      const fd = new FormData();
      fd.append("file", blob, name);
      const { data } = await api.post(`/receipts/${receiptId}/share-link`, fd);
      const link = `${process.env.REACT_APP_BACKEND_URL}/api/public/r/${data.token}`;
      const url = `https://wa.me/${num}?text=${encodeURIComponent(waMessage(schoolName, link, inputs))}`;
      if (win) win.location.href = url; else window.location.href = url;
      toast.success("WhatsApp opened with the parent's chat — tap Send");
    } catch (e) {
      win?.close();
      toast.error(e.response?.data?.detail || "Could not prepare the receipt link");
    } finally { setBusy(null); }
  };

  const sendEmail = async () => {
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(inputs.email || "")) return toast.error("Enter the parent's email on the form first");
    if (!receiptId) return toast.error("Save the receipt first, then email it");
    setBusy("mail");
    try {
      const { blob } = await receiptPdf(name);
      const fd = new FormData();
      fd.append("file", blob, name);
      const { data } = await api.post(`/receipts/${receiptId}/email-parent`, fd);
      toast.success(`Receipt emailed to ${data.to}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not send the email");
    } finally { setBusy(null); }
  };

  const run = async (kind) => {
    if (kind === "wa") return sendWhatsApp();
    if (kind === "mail") return sendEmail();
    setBusy(kind);
    try {
      const { blob } = await receiptPdf(name);
      download(blob, name);
      toast.success("PDF downloaded");
    } catch {
      toast.error("Could not generate PDF");
    } finally { setBusy(null); }
  };

  const B = ({ kind, icon: Icon, label, cls }) => (
    <Button variant="outline" disabled={!!busy} onClick={() => run(kind)} data-testid={`share-${kind}-btn`} className={cls}>
      {busy === kind ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Icon className="mr-2 h-4 w-4" />}{label}
    </Button>
  );
  return (
    <>
      <B kind="wa" icon={MessageCircle} label="WhatsApp" cls="border-green-600/40 text-green-700 hover:bg-green-50" />
      <B kind="mail" icon={Mail} label="Email" />
      <B kind="pdf" icon={Download} label="PDF" />
    </>
  );
};
